import React from 'react';
import * as styles from './index.module.less';
import NottaLogo from '@/images/Logo-Notta-Dark.png';

const NottaLogoLink = () => {
  return (
    <a href="/">
      <img src={NottaLogo} alt="Notta logo" className={styles.notta_logo} />
    </a>
  );
};
export default NottaLogoLink;
